// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","448":"assets/images/defaults/connect.ico","531":"css/base.css","936":"js/bundle.js"}[chunkId] + "-" + {"96":"f573fd7e811970816d53","448":"c05af3fda209bee1d296","531":"5cdad563d8dd2b239542","936":"a7fb64259b378233deb7"}[chunkId] + ".js";
};